import iposApi from '../../api/iposApi';

export const savePaymentTyoes = data => ({
  type: 'SAVE_PAYMENT_TYPES',
  data,
});

export const setPaymentType = data => ({
  type: 'SET_PAYMENT_TYPE',
  data,
});

export const setPayments = data => ({
  type: 'SET_PAYMENTS',
  data,
});

export const loadPaymentTypes = () => async (dispatch, getState) => {
  const {branchInfo, currentLanguageId} = getState();
  const url = '/GetPaymentTypes';
  const params = {
    branchId: branchInfo.branch_guid_code,
    language_id: currentLanguageId
  };

  try {

    const response = await iposApi.get(url, {params});
    const data = response.data.payment_types;
    dispatch(savePaymentTyoes(data));

  } catch (error) {
    dispatch(() => ({type: 'ERROR', data: error}));
  }
};

export const sendConfirmationCode = phoneNumber => async (dispatch, getState) => {
  const {branchInfo} = getState();

  const url = '/GenerateCode';
  const params = {
    branchId: branchInfo.branch_guid_code,
    phone_number: phoneNumber
  };

  const response = await iposApi.get(url, {params});
  return await response.data;
};
